import { timelineFeed } from "@/mocks/home";

const hotRank = [
  { rank: 1, title: "夏日海边 Vlog 4K 修复版", meta: "视频资源 · 8.6 万观看" },
  { rank: 2, title: "「午后街拍」128P 高清套图", meta: "高清套图 · 1.4 万收藏" },
  { rank: 3, title: "私拍福利专题 · 限时 6 组", meta: "私拍福利 · 本期热门" },
  { rank: 4, title: "复古胶片合辑 · 旧日滤镜", meta: "写真合集 · 9,200 收藏" },
  { rank: 5, title: "樱花季节 · 粉色记忆", meta: "美图精选 · 7,800 收藏" },
];

export default function TimelineFeed() {
  return (
    <section id="updates" className="w-full bg-background-100/70 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="text-primary-600 text-xs font-medium tracking-[0.24em] uppercase">
              Live Updates
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
              最新更新 · 快讯流
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-2xl">
              按时间倒序记录套图、视频与福利专题的上新与整理动态，一眼掌握站点节奏。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="lg:col-span-2 bg-background-50 rounded-lg border border-background-200/80 p-5 md:p-7">
            <div className="relative pl-6">
              <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-200" />
              {timelineFeed.map((item, idx) => (
                <article
                  key={item.id}
                  className={`relative ${idx === timelineFeed.length - 1 ? "" : "pb-7"}`}
                >
                  <span className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-background-50 border-2 border-primary-500 flex items-center justify-center" />
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    {item.hot && (
                      <span className="inline-flex items-center gap-1 text-[11px] text-primary-600">
                        <i className="ri-fire-line" />
                        热
                      </span>
                    )}
                  </div>
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">
                    {item.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4 md:gap-6">
            <div className="bg-background-50 rounded-lg border border-background-200/80 p-5 md:p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                  <i className="ri-bar-chart-box-line text-primary-500" />
                  本周热门榜
                </h3>
                <span className="text-xs text-foreground-500">实时</span>
              </div>
              <ol className="flex flex-col gap-3.5">
                {hotRank.map((item) => (
                  <li key={item.rank} className="flex items-start gap-3">
                    <span
                      className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex flex-col min-w-0">
                      <span className="text-sm font-medium text-foreground-900 truncate">
                        {item.title}
                      </span>
                      <span className="text-xs text-foreground-500 mt-0.5">
                        {item.meta}
                      </span>
                    </span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="bg-secondary-500 text-background-50 rounded-lg p-5 md:p-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 mb-3">
                <i className="ri-download-cloud-2-line text-xl" />
              </span>
              <h3 className="font-heading font-bold text-lg">离线收藏指南</h3>
              <p className="text-sm text-background-50/85 mt-2 leading-relaxed">
                学会按合集与主题归档，让心仪的套图与视频资源长久留存、随时回看。
              </p>
              <a
                href="#faq"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-background-50 hover:gap-2.5 transition-all whitespace-nowrap cursor-pointer"
              >
                查看收藏方法
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}